import { registrationNumber } from "./../../../validations/yupValidations";
import { ICreateAndUpdateCompany } from "../../../types/company.interface";
import customAxios from "../../customAxios";
import { CREATE_COMPANY } from "../../routes";

const createCompany = async (formData: ICreateAndUpdateCompany) => {
  try {
    return (
      await customAxios.post(CREATE_COMPANY, {
        address: formData.address,
        lastName: formData.lastName,
        firstName: formData.firstName,
        superAgent: formData.superAgent?._id,
        kartNumber: formData.kartNumber,
        companyName: formData.companyName,
        phoneNumber: formData.phoneNumber,
        shabaNumber: formData.shabaNumber,
        nationalCode: formData.nationalCode,
        nationalId: formData.nationalId,
        registrationNumber: formData.registrationNumber,
        city: formData.city,
        province: formData.province,
        isDriverWallet: formData.isDriverWallet,
        isAdminPozMachine: formData.isAdminPozMachine,
        nationalCardFront: formData.nationalCardFront?.link,
        nationalCardBack: formData.nationalCardBack?.link,
        companyLicence: formData.companyLicence?.link,
        // type: formData.financialGroup,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ CREATE_COMPANY: error });
    return false;
  }
};

export default createCompany;
